module.exports = __webpack_public_path__ + "images/help-videos-preview-me-f1708d40a03065329aef22776389a0ef.png";